import React, { useState, useEffect } from "react";
import waiverForm from "../../attachments/Krupabhishekam_Retreat_2025_Waiver.pdf";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose, faFileAlt } from "@fortawesome/free-solid-svg-icons";
import UtilMethods from "../../util/UtilMethods";

const defaultPoints = {
  sabbath: [
    "You consent to being contacted about the details of the Sabbath Prayers and related Zoom communications.",
    "You agree to allow your contact details to be used for Sabbath prayers by Grace Anointing Ministries.",
    "You have the right to withdraw your consent at any time by contacting us at sabbath@graceanointing.org.",
    "Your personal data will be kept only as long as necessary for the purposes of the Sabbath and communication. Once no longer needed, it will be securely deleted.",
  ],
  retreat_waver: [
    "I willingly accept all risks, known and unknown, associated with participating in retreat activities.",
    "I agree for myself, my heirs, and assigns to hold harmless and release any of the participating individuals, organizers, St. Mary’s Syro Malabar Church, the Syro Malabar Diocese of Chicago, and any other sponsoring organizations, including their subsidiaries, affiliates, officers, directors, licensees, representatives, and successors (collectively “Released Parties”) from any and all losses, causes of action, liabilities, expenses, and claims for damages (“Claims”) that I may now or in the future have arising directly or indirectly from my participation in retreat activities and/or the condition of the property, facilities, or equipment used during the retreat, regardless of when, where, or how such Claims may arise and regardless of whether caused by the negligence of the Released Parties or otherwise. This includes, but is not limited to, Claims relating to:",
    " > (i) Any theft, loss, or disappearance of property.",
    " > (ii) Bodily injury (fatal or non-fatal).",
    " > (iii) Property damage.",
    "This agreement will be construed broadly to prevent claims and lawsuits to the maximum extent permissible under applicable law. Any provisions found to be void or unenforceable shall be modified or deleted to the minimum extent necessary to make them enforceable and shall not affect the enforceability of any other provisions.",
    "I have read this agreement, fully understand its terms, and recognize that I have given up certain legal rights by signing it in consideration of being permitted to participate in the retreat activities.",
    "I have also read and understood the rules and guidelines provided for the Krupabhishekam Retreat 2025 at St. Mary’s Syro Malabar Church, Old Bethpage, NY.",
    "I sign this agreement voluntarily and without any inducement or duress.",
  ],
  sign_in: [
    "You confirm that the information you are providing is accurate and up-to-date.",
    "You consent to receiving event invitations and updates from Grace Anointing Ministries.",
    "You agree to allow your contact details to be shared with event organizers for communication purposes.",
  ], newsletter: [
    "You consent to receiving news and updates from Grace Anointing Ministries.",
  ],
  retreat: [
    "You confirm that the information you are providing is accurate and up-to-date.",
    "You consent to receiving event invitations and updates from Grace Anointing Ministries.",
    "You agree to allow your contact details to be shared with event organizers for communication purposes.",
  ],
};

// Helper function to return the main heading based on type
const getMainHeading = (type) => {
  switch (type) {
    case "sabbath":
      return "By proceeding, you consent to the collection and use of your contact details for Sabbath Zoom registration and communication.";
    case "retreat_waver":
      return "By proceeding, you consent to the waiver form below and to the use of your personal data for registration and further communications.";
    case "retreat":
      return "By proceeding, you consent to the use of your personal data for registration and further communications.";
    case "sign_in":
      return "By proceeding, you consent to the collection and use of your personal data for registration and further communications.";
    default:
      return "Consent";
  }
};

// Helper function to return corresponding icon based on type
const getMessageIcon = (type) => {
  switch (type) {
    case "sabbath":
      return <i className="fas fa-praying-hands"></i>;
    case ("retreat", " retreat_waver"):
      return <i className="fas fa-calendar"></i>;
    default:
      return <i className="fas fa-info-circle"></i>;
  }
};

const ConsentModal = ({
  show,
  type,
  onCancel,
  consentPoints = [],
  consentData = {},
}) => {
  const [waiverSigned, setWaiverSigned] = useState(
    consentData.waiverSigned || false
  );

  useEffect(() => {
    setWaiverSigned(consentData.waiverSigned || false);
  }, [consentData]);

  const pointsToDisplay =
    consentPoints.length > 0 ? consentPoints : defaultPoints[type] || [];

  if (!show) return null;

  return (
    <div className="modal fade show" tabIndex="-1" style={{ display: "block" }}>
      <div className="modal-dialog" style={{ maxWidth: "800px" }}>
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              <span style={{ marginRight: "8px" }}>{getMessageIcon(type)}</span>
              {type === "retreat_waiver" ? "Waiver " : "Consent "} for{" "}
              {type === "retreat"
                ? consentData?.title
                : type.charAt(0).toUpperCase() + type.slice(1)}{" "}
            </h5>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={onCancel}
            ></button>
          </div>
          <div
            className="modal-body"
            style={{
              maxHeight: "400px",
              overflowY: "auto",
              paddingRight: "15px", // Ensures scrollbar doesn't overlap content
            }}
          >
            <p>{getMainHeading(type)}</p>
            <ul>
              {pointsToDisplay.map((point, index) => (
                <li key={index}>{point}</li>
              ))}
            </ul>
            {type === "retreat" && (
              <>
                <div className="mt-3 row">
                  <div className="col-md-6">
                    <label htmlFor="nameField" className="form-label">
                      Name:
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="nameField"
                      value={consentData.name || ""}
                      readOnly
                    />
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="nameField" className="form-label">
                      Date:
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="nameField"
                      value={UtilMethods.formatDate(consentData.date)}
                      readOnly
                    />
                  </div>
                </div>

                <div className="mt-3 row">
                  <div className="col-md-6">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="consentCheckbox"
                      checked={waiverSigned}
                      required
                      onChange={(e) => setWaiverSigned(e.target.checked)}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="consentCheckbox"
                    >
                      <strong>Click to sign.</strong>
                    </label>
                  </div>
                  {/* Download link 
                  <div className="col-md-6">
                    <a
                      href={waiverForm}
                      download
                      className="download-link ms-3"
                      aria-label="Download Waiver Form"
                    >
                      <button
                        className="btn btn-info"
                        title="Download Waiver Form and fill it and bring it to the retreat"
                        aria-label="Download Waiver Form"
                      >
                        <FontAwesomeIcon icon={faFileAlt} /> Download Waiver
                        Form
                      </button>
                    </a>
                  </div>*/}
                </div>
              </>
            )}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => {
                if (type === "retreat") {
                  consentData.waiverSigned = waiverSigned;
                }
                onCancel(waiverSigned);
              }}
            >
              <FontAwesomeIcon icon={faClose} /> Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConsentModal;
